import { Center } from '@chakra-ui/react'
import { IconDefinition } from '@fortawesome/pro-regular-svg-icons'

import { default as WidgetIcon } from 'src/components/widgets/Icon/Icon'
import SocialIcon from 'src/components/widgets/SocialIcon'
import { BrandColor } from 'src/types'

const Icon: React.FC<{
  url?: string
  brandColor: BrandColor
  fallbackIcon?: IconDefinition
}> = ({ url, brandColor, fallbackIcon }) => {
  if (!url && !fallbackIcon) return null
  return (
    <Center
      position="absolute"
      borderRadius="full"
      backgroundColor="white"
      bottom={2}
      right={2}
      w="24px"
      h="24px"
    >
      {url ? (
        <SocialIcon url={url} />
      ) : fallbackIcon ? (
        <WidgetIcon icon={fallbackIcon} color={brandColor} />
      ) : null}
    </Center>
  )
}

export default Icon
